import React, { useEffect, useState, useRef } from 'react';
import { TextReveal } from './TextReveal';
export function Hero() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const sectionRef = useRef<HTMLElement>(null);
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!sectionRef.current) return;
    const rect = sectionRef.current.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };
  return <section ref={sectionRef} onMouseMove={handleMouseMove} className="relative min-h-[70vh] md:min-h-[85vh] flex flex-col justify-center overflow-hidden pt-[108px] pb-[32px] md:pb-[48px]" data-id="element-42">
      {/* Cursor Gradient Follower */}
      <div className="pointer-events-none absolute inset-0 z-0 transition-opacity duration-500" style={{
      background: `radial-gradient(600px circle at ${mousePosition.x}px ${mousePosition.y}px, rgba(132, 204, 22, 0.06), transparent 40%)`
    }} data-id="element-43" />

      <div className="container mx-auto px-6 md:px-12 relative z-10 max-w-7xl" data-id="element-44">
        <div className="mb-8 md:mb-12" data-id="element-45">
          <TextReveal text="BERATUNG   FÜR   ENTSCHEIDER" as="p" className="text-xs md:text-sm font-mono uppercase tracking-[0.3em] text-muted mb-4" delay={0.2} data-id="element-46" />
        </div>

        <div className="max-w-6xl" data-id="element-47">
          <TextReveal text="STRATEGIE." as="h1" className="text-[clamp(3rem,8vw,8rem)] font-black leading-[0.9] tracking-tighter text-white block mb-2" delay={0.4} data-id="element-48" />
          <TextReveal text="STRUKTUR." as="h1" className="text-[clamp(3rem,8vw,8rem)] font-black leading-[0.9] tracking-tighter text-white block mb-2" delay={0.7} data-id="element-49" />
          <TextReveal text="ERFOLG." as="h1" className="text-[clamp(3rem,8vw,8rem)] font-black leading-[0.9] tracking-tighter text-lime block" delay={1} data-id="element-50" />
        </div>

        <div className="mt-12 md:mt-20 max-w-5xl" data-id="element-51">
          <TextReveal text="PP Management & Consulting — Ihre Beratung für nachhaltiges Wachstum." as="p" className="text-lg md:text-xl text-muted font-medium leading-relaxed" delay={1.3} data-id="element-52" />
        </div>
      </div>
    </section>;
}